import React, { useRef, useEffect, useState } from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'
import { isNaN } from 'lodash'

const AppNavbar = ({options, selected, className, highlighted = true, onSelect}) => {
  const activeIndex = options.findIndex(el => el.key === selected)

  const optionRefs = useRef([])
  const containerRef = useRef(null)

  const [tabConfig, setTabConfig] = useState({width: 0, left: 0})

  useEffect(() => {
    const elementsDimensions = optionRefs.current.filter(Boolean).map(el => el.offsetWidth)
    const containerStyles = getComputedStyle(containerRef.current)
    const gap = parseInt(containerStyles.gap)
    const left = elementsDimensions.slice(0, activeIndex).reduce((acc, width) => acc + width + (isNaN(gap) ? 0 : gap), 0)
    setTabConfig({left: left, width: elementsDimensions[activeIndex]})
  }, [activeIndex])

  return (
    <div className={cn(styles.container, className)} ref={containerRef}>
      {
        options.map((option, i) => {
          const isActive = option.key === selected
          return (
            <div key={option.key} ref={ref => optionRefs.current[i] = ref} className={cn(styles.option, {[styles.active]: isActive})} onClick={() => onSelect(option.key)}>
              <div className={styles.title}>{ option.title }</div>
              {
                option.badge
                  ? <div className={styles.badge}>
                      <div className={styles.badgeTitle}>{option.badge}</div>
                    </div>
                  : null
              }
            </div>
          )
        })
      }
      {
        activeIndex >= 0
          ? <div className={cn(styles.tab, {[styles.highlighted]: highlighted})} style={{width: tabConfig.width, transform: `translateX(${tabConfig.left}px)`}}>
            </div>
          : null
      }
    </div>
  )
}

export default AppNavbar
